(() => {
  const root = document.querySelector('[data-yuane-page]');
  if (!root) return;
  const menuButton = document.querySelector('[data-menu-button]');
  const mobilePanel = document.querySelector('[data-mobile-panel]');
  if (menuButton && mobilePanel) {
    menuButton.addEventListener('click', () => {
      const open = mobilePanel.classList.toggle('open');
      menuButton.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('.nav-group[open]').forEach(group => {
      if (!group.contains(event.target)) group.removeAttribute('open');
    });
  });

  const toast = document.querySelector('.toast');
  const showToast = message => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    clearTimeout(window.yuaneToastTimer);
    window.yuaneToastTimer = setTimeout(() => toast.classList.remove('show'), 3200);
  };

  const primary = document.querySelector('[data-primary-purchase]');
  const setSelection = button => {
    if (!primary || !button) return;
    const group = button.hasAttribute('data-scent') ? '[data-scent]' : '[data-wash-variant]';
    document.querySelectorAll(group).forEach(item => item.classList.toggle('active', item === button));
    primary.dataset.selectedVariantId = button.dataset.variantId;
    primary.dataset.selectedProductUrl = button.dataset.productUrl || '';
    const image = document.querySelector('[data-product-image]');
    if (image && button.dataset.productImageUrl) image.src = button.dataset.productImageUrl;
    const label = button.dataset.washVariant || (button.dataset.scent === 'lime' ? 'Lime & Basil' : 'Sandalwood');
    primary.textContent = root.dataset.yuanePage === 'wash' ? `Add Root Reset Wash · ${label}` : `Add Complete System · ${label}`;
  };
  document.querySelectorAll('[data-scent], [data-wash-variant]').forEach(button => button.addEventListener('click', () => setSelection(button)));
  setSelection(document.querySelector('[data-scent].active, [data-wash-variant].active'));

  document.querySelectorAll('[data-carousel]').forEach(carousel => {
    const track = carousel.querySelector('.carousel-track');
    const slides = [...carousel.querySelectorAll('.quote-slide')];
    const dots = [...carousel.querySelectorAll('.dot')];
    let index = 0;
    const render = next => {
      index = (next + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach((dot, i) => { dot.classList.toggle('active', i === index); dot.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    };
    carousel.querySelector('[data-prev]')?.addEventListener('click', () => render(index - 1));
    carousel.querySelector('[data-next]')?.addEventListener('click', () => render(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => render(i)));
    render(0);
  });

  const addSelected = async button => {
    const id = Number(primary?.dataset.selectedVariantId || root.dataset.defaultVariant);
    if (!id) return showToast('This selection is currently unavailable.');
    const original = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding…';
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id, quantity: 1}]})
      });
      if (!response.ok) throw new Error('Cart add failed');
      const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {headers: {'Accept': 'application/json'}}).then(r => r.json());
      document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
      showToast('Added to your bag.');
    } catch (error) {
      showToast('Could not add this item. Please try again.');
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = original;
    }
  };
  document.querySelectorAll('[data-yuane-buy]').forEach(button => button.addEventListener('click', () => addSelected(button)));
  document.querySelectorAll('[data-sticky-purchase]').forEach(sticky => {
    if (!primary) return;
    const update = () => sticky.classList.toggle('visible', primary.getBoundingClientRect().bottom < 0);
    window.addEventListener('scroll', update, {passive: true});
    window.addEventListener('resize', update);
    sticky.querySelector('[data-sticky-buy]')?.addEventListener('click', () => addSelected(primary));
    update();
  });

  const cartForm = document.querySelector('[data-cart-form]');
  const updateButton = cartForm?.querySelector('[data-cart-update]');
  if (cartForm && updateButton) {
    let updateTimer;
    let pendingQuantity;
    let updating = false;
    const submitUpdate = () => {
      const input = pendingQuantity;
      if (updating || !input || input.value === '' || !input.checkValidity()) return;
      updating = true;
      updateButton.disabled = true;
      updateButton.setAttribute('aria-busy', 'true');
      updateButton.textContent = 'Updating…';
      cartForm.requestSubmit(updateButton);
    };
    cartForm.querySelectorAll('[data-cart-quantity]').forEach(input => {
      input.addEventListener('input', () => {
        pendingQuantity = input;
        clearTimeout(updateTimer);
        updateTimer = setTimeout(submitUpdate, 650);
      });
      input.addEventListener('change', () => {
        pendingQuantity = input;
        clearTimeout(updateTimer);
        submitUpdate();
      });
    });
  }
})();